import React from 'react';
import { createRoot } from 'react-dom/client';
import TrustPilotCarouselContainer from './trustpilotReviewsApp';

const root = document.getElementById('trustpilot-reviews');
if (root) {
  createRoot(root).render(<TrustPilotCarouselContainer />);
}
